/**
 * Orlin A1 — keep operators on the loading state instead of treating a slow
 * first Control Bridge build (post-restart / cold doc) as a hard failure.
 */
import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';

const { Paragraph } = Typography;

const HINT_AFTER_MS = 8000;

export const ControlBridgeSlowLoadHint: React.FC<{ active: boolean }> = ({ active }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!active) {
      setShow(false);
      return;
    }
    setShow(false);
    const id = window.setTimeout(() => setShow(true), HINT_AFTER_MS);
    return () => window.clearTimeout(id);
  }, [active]);

  if (!show) return null;

  return (
    <Paragraph
      type="secondary"
      style={{ marginTop: 8, maxWidth: 420, textAlign: 'center' }}
      data-testid="control-bridge-slow-load-hint"
    >
      First load after a restart can take up to a minute while the server warms this
      workspace. Keep this page open — a hard refresh before it finishes can look like a
      failure even though the build is still running.
    </Paragraph>
  );
};
